<script>
import CaringCircle from '@components/safehaven/care-club/caring-circle.vue'

export default {
  page: {
    title: 'Connection Hub - All your health information in one secure place.',
    meta: [
      {
        name: 'description',
        content: 'All your health information in one secure place.',
      },
    ],
  },
  components: {
    CaringCircle,
  },
}
</script>

<template>
  <v-container :class="$style.pageContainer">
    <div class="d-flex mb-7 align-center">
      <v-img
        width="24"
        height="24"
        contain
        :src="require('@assets/images/safehaven/menu_icons/careclub.svg')"
        class="mr-3 flex-grow-0"
      />
      <span :class="[$style.pageTitle, 'flex-grow-1']">CareClub+</span>
    </div>
    <CaringCircle />
  </v-container>
</template>

<style lang="scss" module>
.pageContainer {
  padding-top: 30px !important;
  margin-bottom: 30px !important;
  margin-left: 120px !important;
}

.pageTitle {
  font-size: 18px;
  font-weight: bold;
  line-height: 21px;
  color: #3d3d3d;
}
@media screen and (max-width: 960px) {
  .pageContainer {
    padding-top: 30px !important;
    margin-left: 20px !important;
  }
}

@media screen and (max-width: 450px) {
  .pageContainer {
    margin-left: 10px !important;
  }
}
</style>
